$(function () {

    const $accountBox = $('#accountBox'),
        $navbar = $('#navbarContent'),
        $toggler = $('.navbar-toggler');

    function toggleAccountBox(show) {

        if ($(window).width() > 991) return;

        const shouldShow = show !== undefined
            ? show
            : $accountBox.hasClass('d-none');

        $accountBox.toggleClass('d-none', !shouldShow);

        if (shouldShow) {
            $navbar.collapse('hide');
            $toggler.removeClass('open');
        }
    }

    function mobileEvents() {

        $('.sidebarTitle').off('click').on('click', function () {

            const $this = $(this),
                $ul = $this.next('ul');

            $('.sidebarTitle').not($this)
                .removeClass('activeTitle')
                .next('ul')
                .stop(true, true)
                .slideUp(200);

            $this.toggleClass('activeTitle');
            $ul.stop(true, true).slideToggle(200);

        });

        $('.sidebarTitle + ul li').off('click').on('click', function () {

            let $ul = $(this).closest('ul');

            $ul.slideUp(200)
                .prev('.sidebarTitle')
                .removeClass('activeTitle');

        });

    }

    function resetDesktop() {

        $accountBox.addClass('d-none');

        $navbar.removeClass('show');
        $toggler.removeClass('open');

        $('.subNav, .arrowIconClass, .dropdown')
            .removeClass('openMenu open active');

    }

    function handle() {

        if ($(window).width() <= 767) {

            mobileEvents();

        } else {

            $('.sidebarTitle').removeClass('activeTitle');
            $('.sidebarTitle + ul').removeAttr('style');
            $('.sidebarTitle, .sidebarTitle + ul li').off();

        }

        if ($(window).width() > 991) {
            resetDesktop();
        }

    }

    handle();

    $(window).on('resize orientationchange', handle);

    $('#mobileUserBtn').off('click').on('click', function () {
        toggleAccountBox();
    });

    $toggler.off('click').on('click', function () {

        if ($(window).width() <= 991 && !$accountBox.hasClass('d-none')) {
            toggleAccountBox(false);
        }

        $(this).toggleClass('open');

    });

    $('.arrowIconClass').off('click').on('click', function () {

        $(this).next('.subNav').toggleClass('openMenu')
            .end().toggleClass('open')
            .parent().toggleClass('active');

    });

});

document.addEventListener('DOMContentLoaded', function () {
    var refList = document.querySelector('.article__references ol, .article__references ul');

    if (!refList) return;

    var existingLis = refList.querySelectorAll('li');

    if (existingLis.length > 0) {

        // Already has li's - don't recreate. Only unwrap if nested ol/ul exists.
        var nestedList = refList.querySelector(':scope > ol, :scope > ul');

        if (nestedList) {
            if (nestedList.tagName !== refList.tagName) {
                // Nested list is a different type (ol vs ul) - preserve its type,
                // don't force it into the outer wrapper's tag.
                var newList = document.createElement(nestedList.tagName);
                newList.innerHTML = nestedList.innerHTML;
                // copy any class/id the outer container had
                if (refList.id) newList.id = refList.id;
                if (refList.className) newList.className = refList.className;
                refList.replaceWith(newList);
                refList = newList;
            } else {
                refList.innerHTML = nestedList.innerHTML;
            }
        }

        existingLis = refList.querySelectorAll('li');
        existingLis.forEach(function (li, i) {
            li.id = 'footnote' + (i + 1);
        });

    } else {
        // No li present at all - build from <br> separated content
        const rawHtml = refList.innerHTML;

        const items = rawHtml
            .split(/<br\s*\/?>/gi)
            .map(function (item) { return item.trim(); })
            .filter(function (item) { return item.length > 0; });

        var html = '';
        for (var i = 0; i < items.length; i++) {
            html += '<li id="footnote' + (i + 1) + '">' + items[i] + '</li>';
        }

        refList.innerHTML = html;
    }

    document.querySelectorAll('a[href^="#footnote"]').forEach(function (link) {
        var hash = link.getAttribute('href').slice(1);
        if (!document.getElementById(hash)) {
            var firstId = hash.replace(/-.*$/, '');
            link.addEventListener('click', function (e) {
                e.preventDefault();
                var target = document.getElementById(firstId);
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    });

});


var backToTop = $('#backToTop');
$(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
        backToTop.addClass('show');
    } else {
        backToTop.removeClass('show');
    }
});
backToTop.on('click', function (e) {
    e.preventDefault();
    $('html, body').scrollTop(0);
});


function equalizeElementsHeight({
    wrapperSelector,
    cardSelector,
    targetSelectors,
    breakpoint = 560
}) {

    function applyEqualHeight() {

        const isDesktop = window.innerWidth >= breakpoint;
        const wrappers = document.querySelectorAll(wrapperSelector);

        wrappers.forEach(wrapper => {

            const cards = [...wrapper.querySelectorAll(cardSelector)];

            // Reset heights
            cards.forEach(card => {

                targetSelectors.forEach(selector => {

                    const element = card.querySelector(selector);

                    if (element) {
                        element.style.minHeight = 'auto';
                    }
                });
            });

            // Stop on mobile
            if (!isDesktop) return;

            const rows = {};

            cards.forEach(card => {

                const top = Math.round(card.getBoundingClientRect().top);

                if (!rows[top]) {
                    rows[top] = [];
                }

                rows[top].push(card);
            });

            // Apply equal heights
            Object.values(rows).forEach(rowCards => {

                if (rowCards.length <= 1) return;

                targetSelectors.forEach(selector => {

                    let maxHeight = 0;

                    rowCards.forEach(card => {

                        const element = card.querySelector(selector);

                        if (element) {
                            maxHeight = Math.max(
                                maxHeight,
                                element.getBoundingClientRect().height
                            );
                        }
                    });

                    rowCards.forEach(card => {

                        const element = card.querySelector(selector);

                        if (element) {
                            element.style.minHeight = `${maxHeight}px`;
                        }
                    });
                });
            });
        });
    }

    applyEqualHeight();

    window.addEventListener('load', applyEqualHeight);
    window.addEventListener('resize', applyEqualHeight);

}

equalizeElementsHeight({
    wrapperSelector: '.grid-listing',
    cardSelector: '.card-body',
    targetSelectors: [
        '.card-tags',
        '.card-title',
        '.card-summary'
    ]
});